import { Button, IconButton } from 'components/buttons';
import {
  useHelpCenterStore,
  getShowIgnored,
  getActions,
  getCanPopOut,
  getCanReRunValidations,
} from './HelpCenterStore';

interface IHelpCenterHeaderProps {
  ignoredCount: number;
  count: number;
  title: string;
  hasIgnoreAction: boolean;
}

/**
 * Help center overlay header.
 *
 * Copyright (c) 2021 Decisions All Rights Reserved
 */
export function HelpCenterHeader({ ignoredCount, count, title, hasIgnoreAction }: IHelpCenterHeaderProps) {
  const { reRunValidations, toggleIgnore } = useHelpCenterStore(getActions);
  const showIgnored = useHelpCenterStore(getShowIgnored);
  const canPopOut = useHelpCenterStore(getCanPopOut);
  const { popOutLayer } = useHelpCenterStore(getActions);
  const canReRunValidations = useHelpCenterStore(getCanReRunValidations);

  return (
    <div className="dp-help-center__header">
      <div className="dp-help-center__title">{title}</div>
      <div className="dp-help-center__actions">
        {canReRunValidations && (
          <Button
            textTransform={'capitalize'}
            variant="link"
            className="dp-help-center__action-link dp-help-center__action-link--rerun-validations"
            onClick={reRunValidations}
          >
            Rerun Validations
          </Button>
        )}
        {hasIgnoreAction && (
          <Button
            textTransform={'capitalize'}
            variant="link"
            className="dp-help-center__action-link dp-help-center__action-link--toggle-validations"
            onClick={toggleIgnore}
          >
            {`View ${showIgnored ? ' Not' : ''} Ignored (${!showIgnored ? ignoredCount : count - ignoredCount})`}
          </Button>
        )}
        {canPopOut && (
          <IconButton
            className="dp-help-center__action-link"
            iconClassName="dp-icon--pop-out"
            onClick={popOutLayer}
            aria-label="Open system validations in new tab"
          />
        )}
      </div>
    </div>
  );
}
